<template>
  <ReassuranceItem :variant :with-extra-info>
    <template #icon>
      <RevIllustration
        v-if="isStandardBeforeChristmas || isExpressBeforeChristmas"
        alt=""
        class="h-24 w-24 md:h-32 md:w-32"
        :height="32"
        src="/img/product/delivery-before-christmas.svg"
        :width="32"
      />
      <IconTruckExpress v-else class="h-24 w-24 md:h-32 md:w-32" />
    </template>

    <template #title>
      <slot name="title">
        <span
          v-if="isStandardBeforeChristmas && free"
          data-allow-mismatch="text"
        >
          {{
            i18n(translations.freeShippingBeforeChristmas, {
              earliest: free.earliest,
              latest: free.latest,
            })
          }}
        </span>

        <FormattedMessage
          v-else-if="free"
          :definition="translations.freeShipping"
        >
          <template #dates>
            <span data-allow-mismatch="text">
              {{
                i18n(translations.freeShippingDates, {
                  earliest: free.earliest,
                  latest: free.latest,
                })
              }}
            </span>
          </template>
        </FormattedMessage>

        <span v-else>
          {{ i18n(translations.freeShippingWithoutDates) }}
        </span>
      </slot>
    </template>

    <template v-if="express" #subtitle>
      <span
        :class="{
          'text-static-success-hi':
            isExpressBeforeChristmas && !isStandardBeforeChristmas,
        }"
        data-allow-mismatch="text"
      >
        <template v-if="isExpressBeforeChristmas">
          {{
            i18n(translations.expressShippingBeforeChristmas, {
              amount: express.amount,
              earliest: express.earliest,
              latest: express.latest,
            })
          }}
        </template>
        <template v-else>
          {{
            i18n(translations.expressShipping, {
              amount: express.amount,
              earliest: express.earliest,
              latest: express.latest,
            })
          }}
        </template>
      </span>
    </template>

    <template v-if="withExtraInfo" #extra-info>
      <slot name="extra-info" />
    </template>
  </ReassuranceItem>
</template>

<script lang="ts" setup>
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import translations from '../ReassuranceItems/components/ItemShipping/ItemShipping.translations'
import ReassuranceItem from '../ReassuranceItems/components/ReassuranceItem/ReassuranceItem.vue'

defineProps<{
  free: { earliest: string; latest: string } | null
  express: { earliest: string; latest: string; amount: string } | null
  isStandardBeforeChristmas: boolean
  isExpressBeforeChristmas: boolean
  variant?: 'default' | 'subtle'
  withExtraInfo?: boolean
}>()

const i18n = useI18n()
</script>
